// 需求#2657 专题活动模板功能优化：新增组件类型&样式优化（禅道：http://112.124.122.87:8084/index.php?m=story&f=view&storyID=2657）
// 不想再index.js继续堆代码了。。。

export default class Optimizer2657 {
  constructor() {
    this.handleSeeAll()
    this.handleAnswerSeeAll()
    this.handleDynamicsSeeAll()
    this.handleIcons()
  }

  _eachAll(selector, callback) {
    if (typeof callback !== 'function') return
    const items = Array.from(document.querySelectorAll(selector))
    items.forEach(item => {
      callback(item)
    })
  }

  // 问答组件，判断是否需要显示“...全文”
  handleSeeAll() {
    this._eachAll('.ask-wrap .ask-item', content => {
      if (!content) return
      const desc = content.querySelector('.item-desc')
      if (!desc) return
      // 克隆一个desc出来，看不加省略号的情况下高度多少
      const clonedDesc = desc.cloneNode(true)
      clonedDesc.classList.remove('js-limit-3')
      clonedDesc.classList.add('js-cloned-desc')
      content.appendChild(clonedDesc)

      setTimeout(() => {
        if (clonedDesc.offsetHeight > desc.offsetHeight) {
          const btn = desc.querySelector('.see-all-wrap')
          btn && btn.classList.remove('js-hide')
        }
      }, 50)
    })
  }

  // 回答组件，判断是否需要显示“...全文”
  handleAnswerSeeAll() {
    this._eachAll('.answer_ul .answer_item', content => {
      if (!content) return
      const desc = content.querySelector('.answer_item_desc')
      if (!desc) return
      // 克隆一个desc出来，看不加省略号的情况下高度多少
      const clonedDesc = desc.cloneNode(true)
      clonedDesc.classList.remove('js-limit-3')
      clonedDesc.classList.add('js-cloned-desc')
      content.appendChild(clonedDesc)

      setTimeout(() => {
        if (clonedDesc.offsetHeight > desc.offsetHeight) {
          const btn = desc.querySelector('.see-all-wrap')
          btn && btn.classList.remove('js-hide')
        }
      }, 50)
    })
  }

  // 动态组件，判断是否需要显示“...全文”
  handleDynamicsSeeAll() {
    this._eachAll('.dynamics-list .dynamics-item', content => {
      if (!content) return
      const desc = content.querySelector('.dynamics-text')
      if (!desc) return
      // 克隆一个desc出来，看不加省略号的情况下高度多少
      const clonedDesc = desc.cloneNode(true)
      clonedDesc.classList.remove('js-limit-6')
      clonedDesc.classList.add('js-cloned-desc')
      content.appendChild(clonedDesc)

      setTimeout(() => {
        if (clonedDesc.offsetHeight > desc.offsetHeight) {
          const btn = desc.querySelector('.see-all-wrap')
          btn && btn.classList.remove('js-hide')
        }
      }, 50)
    })
  }

  // 一些写死的icon由前端导入
  handleIcons() {
    // 心理圈·热门话题
    this._eachAll('.hot-topic-list .hot-topic-item', item => {
      const imgUrl = require('../images/icon_fire@2x.png')
      const wrapper = item.querySelector('.hot-topic-left')
      wrapper &&
        wrapper.insertAdjacentHTML(
          'afterbegin',
          `<img src="${imgUrl}" alt="" class="hot-topic-img">`
        )
    })

    // FM
    this._eachAll('.mind-list .mind-item', item => {
      const imgUrl = require('../images/icon_play@2x.png')
      const wrapper = item.querySelector('.mind-avatar-wrap')
      wrapper &&
        wrapper.insertAdjacentHTML(
          'afterbegin',
          `<img src="${imgUrl}" alt="" class="mind-play-btn">`
        )
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotion/template/js/Optimizer2657.js